export function copyToClipboard(id: string) {
  const copyText = document.getElementById(id)?.textContent;
  if (copyText) {
    navigator.clipboard.writeText(copyText);
  }
}
